import { ConflictException, getQuadisLifeInsuranceOfferByLoanId } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { Text } from '@/components/shared/components/Text';
import { useNotificationsContext } from '@/contexts/NotificationsContext/NotificationsContext';
import { downloadFileFromBlob } from '@/utils/downloadFileFromBlob';

export const useDownloadQuadisLifeInsuranceOffer = (loanId: string | undefined) => {
  const {
    actions: { setSnackbarNotification },
  } = useNotificationsContext();

  const [loading, setLoading] = useState(false);

  const downloadQuadisLifeInsuranceOffer = async () => {
    if (!loanId) return;

    setLoading(true);
    try {
      const data = await getQuadisLifeInsuranceOfferByLoanId({ loanId });
      downloadFileFromBlob({ data, fileName: `oferta_seguro_${loanId}`, fileExtension: 'pdf' });
    } catch (error) {
      setSnackbarNotification(
        error instanceof ConflictException
          ? { level: 'warning', msg: <Text tId={'INSURANCE_OFFER_NOT_AVAILABLE_YET'} /> }
          : { level: 'error' },
      );
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return { downloadQuadisLifeInsuranceOffer, loading };
};
